import { tokens } from '@companycam/slab-tokens';
import { Button, Notice, Spinner } from '@companycam/slab-web';
import Steven from 'helpers/steven';
import { translate } from 'javascripts/translations/i18n';
import React from 'react';
import styled from 'styled-components';

type SubmitButtonProps = {
  cta: string;
  handleSubmit: () => void;
  formId: string;
  isWalletPayment: boolean;
  paymentSubmitLoading: boolean;
  submitErrorMessage: string;
  submitPaymentDisabled: boolean;
};

const SubmitButton = styled(Button)`
  width: 100% !important;
  > span {
    display: flex !important;
    flex-direction: row !important;
  }
`;

const StyledSpinner = styled(Spinner)`
  margin-right: var(--cc_size_spacing_xs);
`;

function SubmitPaymentButton({
  cta,
  handleSubmit,
  formId,
  submitErrorMessage,
  submitPaymentDisabled,
  isWalletPayment,
  paymentSubmitLoading,
}: SubmitButtonProps) {
  let submitCta: string = cta;
  if (isWalletPayment) {
    submitCta = translate('billing.stripePaymentModal.continue');
  }
  if (paymentSubmitLoading) {
    submitCta = translate('billing.stripePaymentModal.verifying');
  }

  const handleSubmitClick = () => {
    Steven.elementClicked({
      id: `${formId}_stripe_payment_modal_submit_button`,
      content: cta,
      type: 'button',
      action: `${formId}_stripe_payment_modal_submit_button_clicked`,
    });

    handleSubmit();
  };

  return (
    <>
      <SubmitButton
        onClick={handleSubmitClick}
        data-testid="addPaymentModal__confirm-button"
        disabled={submitPaymentDisabled}
        color="primary"
      >
        {paymentSubmitLoading ? (
          <StyledSpinner
            size={tokens.size_text_m}
            accessibilityLabel={submitCta}
          />
        ) : null}
        {submitCta}
      </SubmitButton>
      {submitErrorMessage ? (
        <Notice
          color="destroy"
          style={{ width: '100%' }}
          ccMargin="m none none none"
        >
          {submitErrorMessage}
        </Notice>
      ) : null}
    </>
  );
}

export default SubmitPaymentButton;
